// @flow
import { combineActions, handleActions } from 'redux-actions';

import { upsertResource, upsertResources } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './actions';
import { mkMemorizedRulesStore } from './types';

const reducer = handleActions({

  // Called when triggering a CRUD operation on transactions. Sagas are also
  // expected to handle the action by initiating the CRUD operation with QCS.
  //
  [combineActions(
    actions.getMemorizedRules,
    actions.createMemorizedRule,
    actions.updateMemorizedRule,
    actions.deleteMemorizedRule,
    actions.makeMemorizedRuleFromTransactionAction,
  )]: (state) => state,

  // Called when a CRUD operation is successful on transactions. The success
  // action is triggered by the Sagas.
  [combineActions(
    actions.getMemorizedRulesSuccess
  )]:
    (state, { payload: data }) => upsertResources(state, data),

  // Called when a CRUD operation is successful on transactions. The success
  // action is triggered by the Sagas.
  [combineActions(
    actions.createMemorizedRuleSuccess,
    actions.updateMemorizedRuleSuccess,
    actions.deleteMemorizedRuleSuccess,
  )]:
    (state, { payload: memorizedRuleToUpsert }) =>
      upsertResource(state, memorizedRuleToUpsert),

  // Called when a CRUD operation fails on transactions. The failure action
  // is triggered by Sagas.
  [combineActions(
    actions.getMemorizedRulesFailure,
    actions.createMemorizedRuleFailure,
    actions.updateMemorizedRuleFailure,
    actions.deleteMemorizedRuleFailure,
  )]:
    (state, { payload: _error }) =>
      // todo: what else should we do with the failure?
      state,

}, mkMemorizedRulesStore());

export const REDUCER_KEY = 'memorizedRuleStore';
export default reducer;
